import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { SectionProps } from '../../utils/SectionProps';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm" style={{ minHeight:"50vh", marginTop: 40 }}>
        <div className={innerClasses}>
          <div className="hero-content">
            <Grid container spacing={1} style={{ textAlign: "left" }}>
              <Grid item md={6} sm={"12"}>
                <h3 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">  Política de privacidade<br /><span className="text-color-success">SiloVirtual</span></h3>
                <p className="text-white mb-3">
                  Desenvolvido por <span className="text-color-success">Ruralhub</span>
                </p>
              </Grid>

              <Grid item md={6} sm={"12"}>
                <img
                  alt="..."
                  className="img-fluid"
                  src={require("../../assets/images/SiloVirtual.png")}
                  style={{ height: "60%" }}
                />
              </Grid>
            </Grid>
              
            
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;